import React from 'react';
import s from './ContentWithLoader.scss';
import { Loader } from '../Loader/Loader';
export const ContentWithLoader = _ref => {
  let {
    isLoading,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: s.container
  }, isLoading && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Loader, null)), /*#__PURE__*/React.createElement("span", {
    style: {
      opacity: isLoading ? 0 : 1
    }
  }, children));
};
//# sourceMappingURL=ContentWithLoader.js.map